export const CONDITION_VALUES = {
  START_TIME: "start_time",
  END_TIME: "end_time",
  ACTIVE_TIME: "active_time",
  NOT_ACTIVE_TIME: "not_active_time",
  BIZ_POINT: "biz_point",
  BIZ_POINT_HOUR: "biz_point_hour",
  CATEGORY_TIME: "category_time",
  CATEGORY_BIZ_POINT: "category_biz_point",
  APPLICATION_TIME: "application_time",
  APPLICATION_BIZ_POINT: "application_biz_point",
  DAILY_WORK_TIME: "daily_work_time",
  WEEKLY_WORK_TIME: "weekly_work_time",
  MONTHLY_WORK_TIME: "monthly_work_time",
  DAILY_OVER_TIME: "daily_over_time",
  WEEKLY_OVER_TIME: "weekly_over_time",
  MONTHLY_OVER_TIME: "monthly_over_time",
  HOLIDAY_WORK_TIME: "holiday_work_time",
  HOLIDAY_ACTIVE_TIME: "holiday_active_time",
  LABELING_RATE: "labeling_rate",
} as const

export const CONDITION_TYPE = [
  {
    label: "勤務開始時間",
    value: CONDITION_VALUES.START_TIME,
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "勤務終了時間",
    value: CONDITION_VALUES.END_TIME,
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "1日の作業時間",
    value: CONDITION_VALUES.ACTIVE_TIME,
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "1日の作業なし時間",
    value: CONDITION_VALUES.NOT_ACTIVE_TIME,
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "1日の合計Biz",
    value: CONDITION_VALUES.BIZ_POINT,
    step: 1000,
    limit: null,
    unit: "biz",
    type: "daily",
  },
  {
    label: "1日の一時間あたりのBiz",
    value: CONDITION_VALUES.BIZ_POINT_HOUR,
    step: 1000,
    limit: null,
    unit: "biz",
    type: "daily",
  },
  {
    label: "1日の分類別使用時間",
    value: CONDITION_VALUES.CATEGORY_TIME,
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "1日の分類別Biz",
    value: CONDITION_VALUES.CATEGORY_BIZ_POINT,
    step: 1000,
    limit: null,
    unit: "biz",
    type: "daily",
  },
  {
    label: "1日のアプリ別使用時間",
    value: CONDITION_VALUES.APPLICATION_TIME,
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "1日のアプリ別Biz",
    value: CONDITION_VALUES.APPLICATION_BIZ_POINT,
    step: 1000,
    limit: null,
    unit: "biz",
    type: "daily",
  },
  {
    label: "1日の勤務時間",
    value: CONDITION_VALUES.DAILY_WORK_TIME,
    step: 1,
    limit: 24,
    unit: "時間",
    type: "daily",
  },
  {
    label: "1週間の勤務時間",
    value: CONDITION_VALUES.WEEKLY_WORK_TIME,
    step: 1,
    limit: 168,
    unit: "時間",
    type: "weekly",
  },
  {
    label: "1ヶ月間の勤務時間",
    value: CONDITION_VALUES.MONTHLY_WORK_TIME,
    step: 10,
    limit: 744,
    unit: "時間",
    type: "monthly",
  },
  {
    label: "1日の残業時間",
    value: CONDITION_VALUES.DAILY_OVER_TIME,
    step: 1,
    limit: 24,
    unit: "時間",
    type: "daily",
  },
  {
    label: "1週間の残業時間",
    value: CONDITION_VALUES.WEEKLY_OVER_TIME,
    step: 1,
    limit: 168,
    unit: "時間",
    type: "weekly",
  },
  {
    label: "1ヶ月間の残業時間",
    value: CONDITION_VALUES.MONTHLY_OVER_TIME,
    step: 1,
    limit: 744,
    unit: "時間",
    type: "monthly",
  },
  {
    label: "休日の勤務時間",
    value: CONDITION_VALUES.HOLIDAY_WORK_TIME,
    step: 1,
    limit: 24,
    unit: "時間",
    type: "daily",
  },
  {
    label: "休日の作業時間",
    value: CONDITION_VALUES.HOLIDAY_ACTIVE_TIME,
    step: 1,
    limit: 24,
    unit: "時間",
    type: "daily",
  },
  {
    label: "業務仕分け率",
    value: CONDITION_VALUES.LABELING_RATE,
    step: 10,
    limit: 100,
    unit: "%",
    type: "daily",
  },
]

export const ATTENDANCE_CONDITION_TYPE = [
  {
    label: "勤務予定開始時間との差",
    value: "attendance_schedule_start_time",
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "勤務予定終了時間との差",
    value: "attendance_schedule_end_time",
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "勤務予定時間との差",
    value: "attendance_schedule_work_time",
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "勤務予定時間",
    value: "attendance_schedule",
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "勤務実績開始時間との差",
    value: "attendance_record_start_time",
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "勤務実績終了時間との差",
    value: "attendance_record_end_time",
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "勤務実績時間との差",
    value: "attendance_record_work_time",
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
  {
    label: "勤務実績時間",
    value: "attendance_record",
    step: 0,
    limit: null,
    unit: "",
    type: "daily",
  },
]

export const OPERATOR_VALUES = {
  LESS_THAN_OR_EQUAL: "less_than_or_equal",
  MORE_THAN_OR_EQUAL: "more_than_or_equal",
} as const

export const OPERATOR_TYPE = [
  {
    label_1: "以前",
    label_2: "以下",
    value: OPERATOR_VALUES.LESS_THAN_OR_EQUAL,
  },
  {
    label_1: "以降",
    label_2: "以上",
    value: OPERATOR_VALUES.MORE_THAN_OR_EQUAL,
  },
]

export const TIMING_VALUES = {
  NEXT_DAY: "next_day",
  NEXT_WEEK: "next_week",
  NEXT_MONTH: "next_month",
  IMMEDIATE: "immediate",
} as const

export const TIMING_TYPE = [
  {
    label: "毎日",
    value: TIMING_VALUES.NEXT_DAY,
  },
  {
    label: "毎週",
    value: TIMING_VALUES.NEXT_WEEK,
  },
  {
    label: "毎月",
    value: TIMING_VALUES.NEXT_MONTH,
  },
  {
    label: "即時",
    value: TIMING_VALUES.IMMEDIATE,
  },
]

export const CATEGORY_NAME = [
  {
    id: 1,
    label: "文章",
    value: "document",
  },
  {
    id: 2,
    label: "コミュニケーション",
    value: "communication",
  },
  {
    id: 3,
    label: "クリエイティブ",
    value: "creative",
  },
  {
    id: 4,
    label: "インターネット",
    value: "internet",
  },
  {
    id: 5,
    label: "経理",
    value: "accounting",
  },
  {
    id: 6,
    label: "営業・マーケティング",
    value: "marketing",
  },
  {
    id: 7,
    label: "その他",
    value: "other",
  },
]
